import { createCheckBoxFilterVar, addPointInteger } from '../common';

let tabledata = [];
const datesSet = new Set();

function getAllDatesFilter(data) {
  data.resultset.forEach((result) => {
    datesSet.add(result[3].replaceAll('-', '/'));
  });
}

function insertTableData(entrie) {
  tabledata.push({
    dat: entrie[3].replaceAll('-', '/'),
    tram: entrie[1],
    int: addPointInteger(entrie[6]),
    vari: addPointInteger((parseFloat(entrie[5]) * 100).toFixed(2)),
    dataRe: entrie[2].replaceAll('-', '/'),
    intRe: addPointInteger(entrie[7]),
  });
}

function processTableData(data) {
  const arrayFilter = Dashboards.getParameterValue('filterVarParam');
  tabledata = [];
  if (data.resultset != null && data.resultset.length > 0) {
    if (arrayFilter.length > 0) {
      for (let j = arrayFilter.length - 1; j >= 0; j -= 1) {
        for (let i = 0; i < data.resultset.length; i += 1) {
          if (arrayFilter[j] === data.resultset[i][3]) {
            insertTableData(data.resultset[i]);
          }
        }
      }
    } else {
      for (let i = 0; i < data.resultset.length; i += 1) {
        insertTableData(data.resultset[i]);
      }
    }
  }
}

function createFilter() {
  const datesArray = Array.from(datesSet);
  createCheckBoxFilterVar(datesArray.length, datesArray);
}

export function tableVariacio(data) {
  getAllDatesFilter(data);
  createFilter();
  processTableData(data);

  const arrayFilter = Dashboards.getParameterValue('filterVarParam');
  // define data array
  if (arrayFilter.length === 0) {
    $('#chartVariacio').hide();
    $('#no_dataChartVariacio').css(
      'background',
      "url('./build/images/nodata1.png') no-repeat top center",
    );
    $('#no_dataChartVariacio').show();
  } else {
    $('#chartVariacio').show();
    $('#no_dataChartVariacio').hide();
  }
  // create Tabulator on DOM element with id "tabulatorMaxCont"
  const table = new Tabulator('#chartVariacio', {
    selectable: false,
    headerSort: false,
    height: 700, // set height of table (in CSS or here), this enables the
    // Virtual DOM and improves render speed dramatically (can be any valid css height value)
    width: 1000,
    data: tabledata, // assign data to table
    layout: 'fitColumns', // fit columns to width of table (optional)
    groupBy: ['dat'],
    columns: [
      // Define Table Columns
      {
        title: 'Data',
        field: 'dat',
        hozAlign: 'center',
        headerHozAlign: 'center',
      },
      {
        title: 'Tram',
        field: 'tram',
        hozAlign: 'center',
        headerHozAlign: 'center',
        width: 560,
      },
      {
        title: 'Intensitat',
        field: 'int',
        hozAlign: 'center',
        headerHozAlign: 'center',
      },
      {
        title: 'Variació',
        field: 'vari',
        hozAlign: 'center',
        headerHozAlign: 'center',
        formatter(cell, formatterParams, onRendered) {
          if (parseFloat(cell.getValue()) < 0) {
            cell.getElement().classList.add('custom-red-cell');
          } else {
            cell.getElement().classList.add('custom-green-cell');
          }
          return cell.getValue();
        },
      },
      {
        title: 'Data Referència',
        field: 'dataRe',
        hozAlign: 'center',
        headerHozAlign: 'center',
      },
      {
        title: 'Intensitat Referència',
        field: 'intRe',
        hozAlign: 'center',
        headerHozAlign: 'center',
      },
    ],
  });
}
